import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from '../../../../service/app_service'
import AuthenticationService from '../../../../service/authentication_service'
import TopBarComponent from '../../component/topbar_component'
import ModalComponent from '../../component/modal_component'
//import "./../../pro_assets/css/protected.css";


var interval = null;
var downloadTimer = null;
const GiveawayPage = () => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [showGiveawayModal, setShowGiveawayModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [amount, setAmount] = useState(0);
    
    const [giveaways, setGiveaways] = useState([]);
    const [clientRef, setClientRef] = useState(null);
    const [name, setName] = useState(null);
    const [question, setQuestion] = useState(null);
    const [duration, setDuration] = useState(null);
    

    useEffect(() => {
        getEvoters(pageNumber);
        //eslint-disable-next-line
        
    }, []);

    const getEvoters = async (pageNumber) => {
        setLoading(true);
        AppService.getEvoters(pageSize, pageNumber).then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setLoading(false);
                setTransactions(rec.list)
                if(rec &&  rec.list){
                    //setTotalTransactionCount(rec.list.length);
                }
            }
        })
    }

    const createEvote = async (data) => {
        setLoading(true);
        AppService.createEvote(data).then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setLoading(false);
                getEvoters(pageNumber)
            }
        })
    }

    const changePage= (val) =>{
        setPageNumber(val)
        getEvoters(val);
    }

    const makePayment = () => {
        let data = {};
        data.name = name;
        data.question = question;
        data.duration = duration;
        console.log("data:", data);
        createEvote(data);
    };
    
    const handleChange = (e) => {
        if(e.target.name === 'name'){
            setName(e.target.value);
        }else if(e.target.name === 'question'){
            setQuestion(e.target.value);
        }else if(e.target.name === 'duration'){
            setDuration(e.target.value);
        }
        

    }



    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head" style={{width: '100%'}}>
                                <h4 className="card-title">My evotes  <em className="text-primary ti ti-reload" style={{paddingLeft: '15px'}}  onClick={() => getEvoters(pageNumber)} /></h4>
                                <div   style={{float: 'right', margin: '10px 0px', width: '100%'}}>
                                    <a className="btn btn-sm btn-outline btn-light" onClick={() => setShowGiveawayModal(true)} style={{float: 'right'}}><em className="text-primary ti ti-files" /><span>Create Evote</span></a>
                                </div>
                            </div>

                            <div className="content-area card"  style={{width: '100%'}}>
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">What is evoting?</h4>
                                    </div>
                                    <p>
                                    Evoting enables people and organisation to conduct some voting electronically.
                                    </p>
                                </div>
                            </div>

                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer" style={{paddingTop: '10px', marginTop: '40px'}}>
                                <div className="table-wrap">
                                
                                <Spin spinning={loading}>
                                <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="" rowSpan={1} colSpan={1}>Name</th>
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Show Result</th>
                                                <th className="data-col dt-account sorting_disabled" rowSpan={1} colSpan={1}>Status</th>
                                                <th className="data-col dt-type sorting_disabled" rowSpan={1} colSpan={1}>
                                                    <div className="dt-type-text">View</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { transactions && transactions.length > 0 && transactions.map((item, i) => {
                                                
                                                return<tr className="data-item odd" role="row" key={i}>
                                                <td className="">
                                                    <div className="d-flex align-items-center">
                                                        <div>
                                                            <span className="d-nones">{item.name}</span>
                                                            <br />
                                                            <span className="d-nones">{item.question}</span>
                                                        </div>
                                                        
                                                    </div>
                                                </td>
                                                <td className="data-col dt-token">
                                                    <a href={"/vote/poll/"+item.uid+''} target="_blank"><span className={"badge badge-outline badge-success " }  >Vote</span></a>
                                                </td>
                                                
                                                <td className="data-col dt-account">
                                                    <span className="lead user-info">{(item && item.closedStatus > 0) ? "CLOSED" : "OPEN"}</span>
                                                    <div className="fake-class"><span className="sub sub-date">{new Date(item.createdAt * 1000).toLocaleString()}</span></div>
                                                </td>
                                                <td className="tnx-type">
                                                    <Link to={"/evoting/detail/"+item.uid}><span className={"tnx-type-md badge badge-outline badge-success badge-md" }  >View</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">P</span></Link> 
                                                </td>
                                            </tr> }) }

                                            {transactions && transactions.length > 0 && <tr>
                                                <Pagination onChange={changePage} pageSize={pageSize} defaultCurrent={pageNumber} current={pageNumber} total={totalTransactionCount} />
                                            </tr>}
                                        </tbody>
                                    </table>
                                </Spin>
                                </div>
                            </div>
                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>


                {showGiveawayModal && <ModalComponent show={setShowGiveawayModal} closeModal={() => setShowGiveawayModal(false)} title="Add Giveaway" >
                    <div >
                        <Spin spinning={loading}>
                            <div className="row scroll-modal" >
                                <div className="col-md-12">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Question</label>
                                        <input type="text" name="question" value={question} className="input-bordered" placeholder="Question" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Group/Company Name</label>
                                        <input type="text" name="name" value={name} className="input-bordered" placeholder="Name" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Duration in hours</label>
                                        <input type="number" name="duration" value={duration} className="input-bordered" placeholder="How many hours" onChange={handleChange} />
                                    </div>
                                </div>
                                

                                <div className="col-md-12">
                                    {<Popconfirm
                                        title="Are you sure to submit this action?"
                                        onConfirm={makePayment}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Save</button>
                                    </Popconfirm>}
                                </div>

                            </div>
                        </Spin>

                    </div>
                </ModalComponent>}




        </div>
    );

}

export default withRouter(GiveawayPage);
